import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/config/site";

const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header data-testid="site-nav" className="fixed inset-x-0 top-0 z-50 bg-coacher-navy/95 backdrop-blur-md border-b border-white/10">
      <div className="mx-auto flex h-16 sm:h-20 max-w-7xl items-center justify-between px-4 sm:px-8">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="CoachER crest" className="h-9 w-9 sm:h-10 sm:w-10 rounded-lg" />
          <span className="font-display text-xl sm:text-2xl font-semibold uppercase tracking-wide text-white">
            Coach<span className="text-white">ER</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `relative pb-1 text-sm font-medium tracking-wide transition-colors duration-200 ${
                  isActive
                    ? "text-white after:absolute after:inset-x-0 after:-bottom-0.5 after:h-0.5 after:bg-coacher-red"
                    : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/pricing"
            data-testid="nav-trial-cta"
            className="hidden sm:inline-flex items-center rounded-md bg-coacher-red px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-coacher-red-dark"
          >
            Start Free Trial
          </Link>
          <button
            data-testid="nav-mobile-menu-button"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-white/10 bg-coacher-navy px-4 py-4" aria-label="Mobile">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testId}-mobile`}
              className={({ isActive }) =>
                `block rounded-md px-3 py-3 text-base font-medium ${isActive ? "bg-white/10 text-white" : "text-white/70 hover:text-white"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/pricing"
            data-testid="nav-trial-cta-mobile"
            className="mt-3 block rounded-md bg-coacher-red px-3 py-3 text-center text-base font-semibold text-white"
          >
            Start Free Trial
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Nav;
